/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

// convertDtoToClevertap = form::Object,{ exclude::Array|String, excludeIfHasWord::String } -> Object
function convertDtoToClevertap(form, { exclude, excludeIfHasWord }) {
  // exclude can be array or string
  const obj = {};
  // eslint-disable-next-line no-nested-ternary, no-param-reassign
  exclude = Array.isArray(exclude)
    ? exclude // if array[], just assign it
    : typeof exclude === 'string'
    ? [exclude] // if string return array<String>
    : []; // else return empty array

  function assignAndFormatKey(formObj, clevertapResultObj, prefixKey) {
    Object.keys(formObj).forEach((key) => {
      // check if value has another nested object, if so run recursively
      const value = formObj[key];
      if (value instanceof Object) {
        // if emergencyContact, include the name for readability
        const _prefix =
          key.toLowerCase().indexOf('emergency') >= 0 ? 'Emergency' : '';
        return assignAndFormatKey(value, clevertapResultObj, _prefix);
      }

      let formattedKey = key
        .split('_')
        // capitalize each word
        .map((word) => word[0].toUpperCase() + word.slice(1))
        .join(' ')
        .trimLeft();
      formattedKey = `${prefixKey} ${formattedKey}`.trim();

      // else if the key is not excluded, assign the key and value to obj
      if (exclude.indexOf(key) < 0 && key.indexOf(excludeIfHasWord) < 0) {
        clevertapResultObj[formattedKey] = formObj[key];
      }
    });
  }
  assignAndFormatKey(form, obj, '');

  return obj;
}

export function capitalMenuItem() {
  pushClevertapEvent('Clicked Capital menu', {});
}

export function capitalClickApplyForLoan() {
  pushClevertapEvent('Interested to Apply', {});
}

export function capitalClickAllow() {
  pushClevertapEvent('Granted Permission', {});
}

export function incompleteProfile() {
  pushClevertapEvent('Incomplete Profile', {});
}

export function capitalClickCancel() {
  pushClevertapEvent('Rejected Permission', {});
}

export function capitalClickDeniedAllow() {
  pushClevertapEvent('Granted Permission Later', {});
}

export function capitalDeniedCancel() {
  pushClevertapEvent('Rejected Permission Again', {});
}

export function changeTenure(tenor) {
  pushClevertapEvent(`${tenor} months tenure`, {});
}

export function capitalClickApplyNow({
  tenure,
  rate,
  maxLoan,
  amount,
  lender,
}) {
  pushClevertapEvent('Applied for Loan', {
    Tenure: tenure,
    'Interest Rate': rate,
    'Max Loan Amount': maxLoan,
    'Loan amount': amount,
    Lender: lender,
  });
}

export function preApprovalRejection() {
  pushClevertapEvent('Pre-Approval Rejection', {});
}

export function submitFormCapitalModalku(form, isSubmitSuccess) {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ excludeIfHasWord: string; }' i... Remove this comment to see the full error message
  const clevertapObj = convertDtoToClevertap(form, {
    excludeIfHasWord: 'data_url',
  });
  clevertapObj['Submit status'] = isSubmitSuccess ? 'Success' : 'Failed';
  pushClevertapEvent('Submit Document', clevertapObj);
}

export function submitFormCapitalKoinworks(form, isSubmitSuccess) {
  pushClevertapEvent('Submit Document', {
    'Loan Type': form.loans_type,
    'Submit status': isSubmitSuccess ? 'Success' : 'Failed',
    Tenure: form.duration,
    'Interest Rate': form.interest_rate,
    'Max Loan Amount': form.maxLoan,
    'Loan amount': form.pre_approved_amount,
    Lender: form.lender_name,
    Name: form.personal_info.name,
    NIK: form.personal_info.nik,
    'Date of Birth': form.personal_info.birth_date,
    'Marital Status': form.personal_info.marital_status,
    'Business Email': form.personal_info.email,
    'Phone Number': form.personal_info.phone_number,
    Address: form.personal_info.home_address,
    City: form.personal_info.home_city,
    Province: form.personal_info.home_province,
    'Postal Code': form.personal_info.home_zipcode,
    'Business Address': form.personal_info.business_address,
    'Business City': form.personal_info.business_city,
    'Business Province': form.personal_info.business_province,
    'Business Postal Code': form.personal_info.business_zipcode,
    'Business Start Month': form.personal_info.business_start_month,
    'Business Start Year': form.personal_info.business_start_year,
    'Home Phone Number': form.personal_info.home_phone_number,
    'Personal Email': form.personal_info.personal_email,
    'Business Name': form.personal_info.business_name,
    'Bank Name': form.personal_info.bank_name,
    'Account Number': form.personal_info.account_no,
    'Bank Branch Name': form.personal_info.bank_branch_name,
    'Bank Account Name': form.personal_info.bank_account_name,
    'Emergency Name': form.emergency_contact_info.name,
    'Emergency Relationship': form.emergency_contact_info.relationship,
    'Emergency Contact': form.emergency_contact_info.contact_no,
    'Emergency Address': form.emergency_contact_info.address,
  });
}

export function submitFormCapitalTaralite(form, isSubmitSuccess) {
  pushClevertapEvent('Submit Document', {
    'Submit status': isSubmitSuccess ? 'Success' : 'Failed',
    'Loan Amount': form.loan_amount,
    'Loan Duration': form.duration,
    'Interest Rate': form.interest_rate,
    'Loan Purpose': form.loan_purpose,
    Lender: form.lender_name,
    'First Name': form.first_name,
    'Last Name': form.last_name,
    Email: form.email,
    'Phone Number': form.phone_number,
    NIK: form.ktp,
    NPWP: form.npwp,
    Gender: form.gender_type,
    'Marital Status': form.marital_status_type,
    'Place of Birth': form.place_of_birth,
    'Date of Birth': form.date_of_birth,
    'Mother Name': form.mother_name,
    Address: form.address.full_address,
    City: form.address.city,
    Province: form.address.province,
    'Postal Code': form.address.postal_code,
    'Bank Name': form.bank_account.bank_name,
    'Account Number': form.bank_account.account_number,
    'Account Holder Name': form.bank_account.account_holder,
    'Emergency Name': form.emergency_contact.full_name,
    'Emergency Relationship': form.emergency_contact.relationship,
    'Emergency Contact': form.emergency_contact.phone_number,
    'Business Name': form.business_detail.business_name,
    'Business Join Date': form.business_detail.join_date,
    'Business Address': form.business_detail.address.full_address,
    'Business City': form.business_detail.address.city,
    'Business Province': form.business_detail.address.province,
    'Business Postal Code': form.business_detail.address.postal_code,
  });
}

export function submitFormCapitalByLenderNameAndSubmitStatus(
  form,
  isSubmitSuccess
) {
  // eslint-disable-next-line default-case
  switch (form.lender_name.toLowerCase()) {
    case 'koinworks':
      submitFormCapitalKoinworks(form, isSubmitSuccess);
      break;
    case 'taralite':
      submitFormCapitalTaralite(form, isSubmitSuccess);
      break;
    case 'modalku':
      submitFormCapitalModalku(form, isSubmitSuccess);
      break;
  }
}

export function uploadImageForm(fileName, id) {
  pushClevertapEvent(`${id} File Set to Upload`, {
    'File Name': fileName,
  });
}

export function capitalClickChange({ tenure, rate, maxLoan, amount, lender }) {
  pushClevertapEvent('Change Details', {
    Tenure: tenure,
    'Interest Rate': rate,
    'Max Loan Amount': maxLoan,
    'Loan amount': amount,
    Lender: lender,
  });
}

export function backToDashBoard() {
  pushClevertapEvent('Dashboard via Submission Page', {});
}

export function capitalClickContractSigned({ tenure, rate, amount, lender }) {
  pushClevertapEvent('Contract Signed', {
    Tenure: tenure,
    'Interest Rate': rate,
    'Loan amount': amount,
    Lender: lender,
  });
}

export function capitalClickViewContract({ tenure, rate, amount, lender }) {
  pushClevertapEvent('Contract Viewed', {
    Tenure: tenure,
    'Interest Rate': rate,
    'Loan amount': amount,
    Lender: lender,
  });
}

export function capitalClickApplyMore({
  userId,
  businessId,
  businessName,
  businessTypeId,
  businessCategoryId,
}) {
  pushClevertapEvent('Apply more loans', {
    'Current User ID': userId,
    'Current Business ID': businessId,
    'Current Business Name': businessName,
    'Current Business Type ID': businessTypeId,
    'Current Business Category ID': businessCategoryId,
  });
}

export function showDetail({ lenderName, tenure, rate, maxAmount }) {
  pushClevertapEvent(`Clicked ${lenderName} Show Details`, {
    Tenure: `${tenure} Months`,
    'Interest Rate': rate,
    'Max Loan Amount': maxAmount,
  });
}
